import { Button } from "reactstrap";
import React from "react";
import ModalInterface from "../ModalInterface";
import { useState } from "react";

const NewSessionModal = ({
  showNewSessionModal,
  setShowNewSessionModal,
  blId,
}) => {
  const [sessionName, setSessionName] = useState("");
  const [tableNumber, setTableNumber] = useState("");

  const handleOpenSession = () => {
    if (!tableNumber) {
      return;
    }

    if (!sessionName) {
      return;
    }

    // // Recupero il base url dal file di configurazione
    var baseUrl = process.env.REACT_APP_BASE_URL_FO;
    // Aggiungo i parametri al base url
    baseUrl =
      baseUrl +
      "?buid=" +
      blId +
      "&table_no=" +
      tableNumber +
      "&session_name=" +
      sessionName.toUpperCase();
    // Apro una nuova scheda con l'url generato
    window.open(baseUrl, "_blank");

    closeModal();
  };

  // Funzione per la gestione della chiusura
  function closeModal() {
    // Ripristino i valori
    setSessionName("");
    setTableNumber("");

    // Chiudo la modale
    setShowNewSessionModal(false);
  }

  return (
    <>
      <ModalInterface
        display={showNewSessionModal}
        center="true"
        handleClose={() => {
          closeModal();
        }}
        title={<>{<span>Neue Session</span>}</>}
        content={
          <>
            <div className="text-center mt-0 pt-0 mb-2">
              <input
                placeholder="Tischnummer"
                type="number"
                className="input-modal mb-2"
                style={{ fontSize: "24px" }}
                value={tableNumber}
                onChange={(e) => {
                  setTableNumber(e.target.value);
                }}
              />

              <input
                placeholder="Tischname"
                type="text"
                className="input-modal"
                style={{ fontSize: "24px" }}
                value={sessionName}
                onChange={(e) => {
                  setSessionName(e.target.value);
                }}
              />

              <div className="mt-4">
                <Button
                  className="bg-danger text-white p-2 ps-3 pe-3 me-3"
                  style={{ width: "120px" }}
                  role="button"
                  onClick={() => {
                    closeModal();
                  }}
                >
                  Abbrechen
                </Button>
                <Button
                  className="text-white p-2 ps-3 pe-3"
                  style={{ backgroundColor: "#213039", width: "120px" }}
                  role="button"
                  onClick={() => {
                    handleOpenSession();
                  }}
                >
                  Erstelle
                </Button>
              </div>
            </div>
          </>
        }
      />
    </>
  );
};

export default NewSessionModal;
